import type { RouteRecordRaw } from 'vue-router';

export const AUTHORITY_ROUTER: RouteRecordRaw = {
  path: '/admin/authority',
  component: () => import('@/modules/admin/authority/views/Authority.vue'),
  name: 'Authority',
  meta: {
    title: '권한 관리',
    requiresAuth: true,
    keepAlive: true,
  },
};
